import { ListRequest } from '../../providers/request/list-request.model';
import { OrderType } from '../../providers/request/order-type.enum';
import { OrganizationType } from '../staff/organization-type.enum';
import { ArchiveKeepPeriodType } from './archive-keep-period-type.enum';
import { ArchiveSecretLevel } from './archive-secret-level.enum';
import { ArchiveSortRuleInfo } from './archive-sort-rule-info.model';
import { ArchiveStatus } from './archive-status.enum';
import { ArchiveVolumeCreateType } from './archive-volume-create-type.enum';
import { ArchiveVolumeFileRule } from './archive-volume-file-rule.enum';
import { ArchiveVolumePageType } from './archive-volume-page-type.enum';
export class ArchiveVolumeListRequest extends ListRequest {
  filePageCount?: number;
  signFilePageCount?: number;
  printedFilePageCount?: number;
  fileCount?: number;
  signFileCount?: number;
  printedFileCount?: number;
  signFileRate?: number;
  fileSize?: number;
  signFileSize?: number;
  printedFileSize?: number;
  fileAttachPageCount?: number;
  signFileAttachPageCount?: number;
  printedFileAttachPageCount?: number;
  fileAttachCount?: number;
  signFileAttachCount?: number;
  printedFileAttachCount?: number;
  signFileAttachRate?: number;
  fileAttachSize?: number;
  signFileAttachSize?: number;
  printedFileAttachSize?: number;
  notArchivingFileCount?: number;
  notArchivingFilePageCount?: number;
  notArchivingFileSize?: number;
  notArchivingFileAttachCount?: number;
  notArchivingFileAttachPageCount?: number;
  notArchivingFileAttachSize?: number;
  createType?: ArchiveVolumeCreateType;
  volumePageType?: ArchiveVolumePageType;
  volumePageLimit?: number;
  projectId?: number;
  sectionId?: number;
  dwTypeCode?: string;
  dwTypeName?: string;
  catalogId?: number;
  catalogIds?: Array<number>;
  catalogSectionType?: OrganizationType;
  code?: string;
  codeSn?: number;
  seeAlsoCode?: string;
  name?: string;
  title?: string;
  startTime?: number;
  finishTime?: number;
  keepPeriodType?: ArchiveKeepPeriodType;
  secretLevel?: ArchiveSecretLevel;
  createUnit?: string;
  sortRules?: Array<ArchiveSortRuleInfo>;
  fileRule?: ArchiveVolumeFileRule;
  sectionItemId?: number;
  materialTypeId?: number;
  materialModelId?: number;
  materialYear?: string;
  status?: ArchiveStatus;
  statusList?: Array<ArchiveStatus>;
  sortOrder?: number;
  comment?: string;
  fileStatusComment?: string;
  filePageCountOrder?: OrderType;
  titleOrder?: OrderType;
  sortOrderOrder?: OrderType;
  commentOrder?: OrderType;
  catalogPathOrder?: OrderType;
  orderedSortFields?: string[];
}
